import {useEffect, useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { startAuthentication } from "@simplewebauthn/browser";
import { AuthContext } from "../helpers/AuthContext";

import { loadConfig } from "../helpers/config";
import LoadingSpinner from "../components/LoadingSpinner";
import "./Login.css";

function Login() {
  const navigate = useNavigate();
  const [apiUrl, setApiUrl] = useState("");
  const [loadingConfig, setLoadingConfig] = useState(true);


  useEffect(() => {
    async function fetchConfig() {
      let url = await loadConfig();
      setApiUrl(url.APIURL);
      setLoadingConfig(false);
    }
    fetchConfig();
  }, []);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setAuthState } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [passkeyLoading, setPasskeyLoading] = useState(false);
  const passkeySupported =
    typeof window !== "undefined" &&
    typeof window.PublicKeyCredential !== "undefined";


  
  if (loadingConfig) {
    return <LoadingSpinner text="Lade Konfiguration..." />;
  }



  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post(`${apiUrl}/auth/login`, { username, password })
      .then((response) => {
        if (response.data.error) {
          setError(response.data.error);
        } else {
          localStorage.setItem("accessToken", response.data.token);
          setAuthState({
            username: response.data.username,
            id: response.data.id,
            status: true,
            isAdmin: response.data.isAdmin,
            canAccessLicenses: response.data.canAccessLicenses || false,
          });
          navigate("/");
        }
      })
      .catch((error) => {
        // Check if it's a network error (backend down)
        if (!error.response) {
          setError("Das System ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.");
        } else if (error.response.status === 401 || error.response.status === 400) {
          // Wrong credentials
          setError("Login fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.");
        } else {
          // Other errors
          setError("Login fehlgeschlagen. Bitte versuchen Sie es erneut.");
        }
      });
  };

  if (loadingConfig) {
    return "<div>Lade Konfiguration...</div>";
  }

  const handlePasskeyLogin = async () => {
    setError("");
    setPasskeyLoading(true);
    try {
      const { data: { requestId, options } } = await axios.post(
        `${apiUrl}/auth/webauthn/authenticate/options`
      );
      const assertionResponse = await startAuthentication({ optionsJSON: options });
      const { data } = await axios.post(`${apiUrl}/auth/webauthn/authenticate/verify`, {
        requestId,
        assertionResponse,
      });
      localStorage.setItem("accessToken", data.token);
      setAuthState({
        username: data.username,
        id: data.id,
        status: true,
        isAdmin: data.isAdmin,
        canAccessLicenses: data.canAccessLicenses || false,
      });
      navigate("/");
    } catch (err) {
      console.error("Passkey login error:", err);
      if (err.name === "NotAllowedError") {
        // User cancelled the passkey prompt, no error needed
      } else if (err.response) {
        setError(err.response.data?.error || "Passkey-Login fehlgeschlagen. Bitte versuchen Sie es erneut oder nutzen Sie Benutzername und Passwort.");
      } else if (err.request) {
        setError("Das System ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.");
      } else {
        setError(`Passkey-Login fehlgeschlagen (${err.name}: ${err.message})`);
      }
    }
    setPasskeyLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/favicon.ico" alt="logo" style={{ width: '100px', margin: '0 auto 20px' }} />
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Benutzername</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Passwort</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="login-error">{error}</div>}
          <button className="login-btn" type="submit">Login</button>
        </form>
        {passkeySupported && (
          <>
            <div className="login-divider">oder</div>
            <button
              type="button"
              className="login-btn login-btn-secondary"
              onClick={handlePasskeyLogin}
              disabled={passkeyLoading}
            >
              {passkeyLoading ? "Warte auf Passkey…" : "Mit Passkey anmelden"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Login;
